import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import SiteBreadcrumbs from '@/components/SiteBreadcrumbs.vue'
    import SiteHeader from '@/components/SiteHeader.vue'
    import SiteFooter from '@/components/SiteFooter.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'SiteLayout',
  setup(__props) {

    
return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SiteHeader),
    _createVNode(_component_v_main, { class: "align-center justify-center pt-0" }, {
      default: _withCtx(() => [
        _createVNode(SiteBreadcrumbs),
        _createVNode(_component_router_view)
      ]),
      _: 1
    }),
    _createVNode(SiteFooter)
  ], 64))
}
}

})